import React, {useEffect, useState} from "react";
import {useParams, useNavigate} from 'react-router-dom';
import {alertAfterFunction, defaultAlert, defaultConfirm} from "../../../utils/alert";
import {getMemberChargeDetail, saveChargeCancelData} from "../../../api/transaction/chargeApi";
import {ChargeCancelRequestTypes, ChargeTypes} from "../../../types/transaction/transaction.types";
import {formatDateTime, setComma} from "../../../utils/format";
import {requestPaymentCancel} from "../../../services/payment/paymentService";


const ChargeDetailPage = () => {
    const navigate = useNavigate();
    const {id} = useParams<{ id: string }>();

    const [chargeData, setChargeData] = useState<ChargeTypes>();

    const [loading, setLoading] = useState(false);

    const getChargeDetailData = async () => {
        if (!id) return;
        try {
            setLoading(true);
            const result = await getMemberChargeDetail(id);
            if (result.data.code == "00") {
                setChargeData(result.data.data);
            }
        } catch (err) {
            console.error('충전 상세 에러:', err);
        } finally {
            setLoading(false);
        }
    };

    const chargeCancel = () => {
        defaultConfirm("충전 취소 하시겠습니까?", "확인", "취소", async (isConfirmed) => {
            if (isConfirmed && chargeData) {
                // 충전 취소 요청
                try {
                    const cancelRes = await requestPaymentCancel(chargeData.paymentTransactionId || "", "사용자 취소");
                    if (cancelRes.data.success && id) {
                        // 결제 취소 정보 저장
                        // 무조건 수수료 포함 전액 취소
                        const cancelReqData: ChargeCancelRequestTypes = {
                            transactionCode: id,
                            paymentTransactionId: cancelRes.data.tid
                        }

                        const response = await saveChargeCancelData(cancelReqData);

                        if (response.data.code === "00") {
                            alertAfterFunction("충전이 취소되었습니다.", () => navigate('/wallet/charge-list'));
                        }

                    } else {
                        defaultAlert("PG사 결제 취소에 실패했습니다.");
                        return;
                    }
                } catch (error) {
                    console.error('충전 취소 요청 실패:', error);
                }
            }
        })
    }


    useEffect(() => {
        getChargeDetailData();
    }, [])

    // 아래 데이터 가공해서 뿌려주기 필요 및 충전 취소 기능 필요
    return (
        <>
            {(!loading && chargeData) && (() => {
                const isCancelPossible = chargeData.cancelPossible;
                const paymentMethod = chargeData.paymentMethod === "ADJUSTMENT" ? "관리자 지급" : "계좌이체";

                const isCancel = chargeData.chargeType === "CHARGE_CANCEL" && chargeData.parentChargeCode;

                const statusText = isCancel  ? "충전취소" : "충전완료";
                const statusClass = isCancel  ? "cancel" : "finish";

                const chargeAmount = setComma(chargeData.amount);

                return (
                    <div>
                        {isCancelPossible && (
                            <div className="bottom-btn">
                                <button
                                    type="button"
                                    className="btn cancel"
                                    onClick={chargeCancel}
                                >
                                    충전 취소
                                </button>
                            </div>
                        )}
                        <main className="container type_gray">
                            <section className="bg-white">
                                <div className="inner-box">
                                    <h3 className="dot-tit">기본 정보</h3>
                                    <ul className="detail-info">
                                        <li>
                                            <span className="tit">충전금액</span>
                                            <span className="txt">{chargeAmount} 원</span>
                                        </li>
                                        <li>
                                            <span className="tit">충전일시</span>
                                            <span className="txt">{formatDateTime(chargeData.regDate)}</span>
                                        </li>
                                        <li>
                                            <span className="tit">거래번호</span>
                                            <span className="txt">{chargeData.transactionCode}</span>
                                        </li>
                                        <li>
                                            <span className="tit">거래상태</span>
                                            <span className={"status " + statusClass}>{statusText}</span>
                                        </li>
                                    </ul>
                                </div>
                            </section>


                            {isCancel ? (
                                <section className="bg-white">
                                    <div className="inner-box">
                                        <h3 className="dot-tit">원거래 정보</h3>
                                        <ul className="detail-info">
                                            <li><span className="tit">거래번호</span><span className="txt">{chargeData.parentChargeCode}</span>
                                            </li>
                                            <li><span className="tit">거래일시</span><span className="txt">{formatDateTime(chargeData.parentChargeDate)}</span>
                                            </li>
                                            <li><span className="tit">결제금액</span><span className="txt">{setComma(chargeData.parentPaymentAmount)} 원</span>
                                            </li>
                                            <li><span className="tit">결제수단</span><span className="txt">{chargeData.parentPaymentMethod == "BANK_ACCOUNT" ? "계좌이체" : "-"}</span></li>
                                        </ul>
                                    </div>
                                </section>
                            ) : (
                                <section className="bg-white">
                                    <div className="inner-box">
                                        <h3 className="dot-tit">결제 정보</h3>
                                        <ul className="detail-info">
                                            <li>
                                                <span className="tit">결제수단</span>
                                                <span className="txt">{paymentMethod}</span>
                                            </li>
                                            <li>
                                                <span className="tit">결제금액</span>
                                                <span className="txt">{setComma(chargeData.amount)} 원</span>
                                            </li>
                                            <li>
                                                <span className="tit">충전수수료</span>
                                                <span className="txt">{setComma(chargeData.chargeFee)} 원</span>
                                            </li>
                                        </ul>
                                    </div>
                                </section>
                            )}

                            <section className="bg-white">
                                <div className="inner-box">
                                    <h3 className="dot-tit">WINPAY 정보</h3>
                                    <ul className="detail-info">
                                        <li>
                                            <span className="tit">거래 전 잔액</span>
                                            <span className="txt">{setComma(chargeData.balanceBefore)} 원</span>
                                        </li>
                                        <li>
                                            <span className="tit">거래 후 잔액</span>
                                            <span className="txt">{setComma(chargeData.balanceAfter)} 원</span>
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            {isCancelPossible && (
                                <section>
                                    <div className="inner">
                                        <ul className="guidF-list">
                                            <li>
                                                충전금액을 사용하지 않은 경우 충전일로부터 7일 이내 취소할 수 있습니다.
                                            </li>
                                            <li>
                                                취소 시 원거래 결제수단으로 자동 승인취소 처리됩니다.
                                            </li>
                                        </ul>
                                    </div>
                                </section>
                            )}
                        </main>
                    </div>
                );
            })()}
        </>
    );
};
export default ChargeDetailPage;